import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal display-block"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "modal display-block background-modal" }, null, -1 /* HOISTED */)
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered modal-xmedium setting-modal",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-label" }
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "select" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", { value: "ja" }, "日本語", -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "en" }, "English", -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "form-label" }
const _hoisted_19 = ["textContent"]
const _hoisted_20 = { class: "select" }
const _hoisted_21 = { value: "0" }
const _hoisted_22 = { value: "1" }
const _hoisted_23 = { value: "2" }
const _hoisted_24 = { value: "3" }
const _hoisted_25 = { value: "4" }
const _hoisted_26 = { class: "modal-footer btn-group" }
const _hoisted_27 = ["textContent"]
const _hoisted_28 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOpenSetting)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h5", {
                class: "modal-title",
                id: "exampleModalLongTitle",
                textContent: _toDisplayString(_ctx.t$('header.setting.title'))
              }, null, 8 /* PROPS */, _hoisted_6),
              _createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSetting && _ctx.closeSetting(...args)))
              }, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, [
                    _createElementVNode("strong", {
                      textContent: _toDisplayString(_ctx.t$('header.setting.language'))
                    }, null, 8 /* PROPS */, _hoisted_12)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.settingModel.lang) = $event))
                    }, _hoisted_16, 512 /* NEED_PATCH */), [
                      [_vModelSelect, _ctx.settingModel.lang]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, [
                    _createElementVNode("strong", {
                      textContent: _toDisplayString(_ctx.t$('header.setting.autoLogoutTime'))
                    }, null, 8 /* PROPS */, _hoisted_19)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.settingModel.timeLogout) = $event))
                    }, [
                      _createTextVNode(" //TODO: "),
                      _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.t$('header.pulldown.never')), 1 /* TEXT */),
                      _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.t$('header.pulldown.5m')), 1 /* TEXT */),
                      _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.t$('header.pulldown.10m')), 1 /* TEXT */),
                      _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.t$('header.pulldown.30m')), 1 /* TEXT */),
                      _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.t$('header.pulldown.1h')), 1 /* TEXT */)
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, _ctx.settingModel.timeLogout]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn--second",
                "data-dismiss": "modal",
                textContent: _toDisplayString(_ctx.t$('header.setting.cancel')),
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeSetting && _ctx.closeSetting(...args)))
              }, null, 8 /* PROPS */, _hoisted_27),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn--primary",
                textContent: _toDisplayString(_ctx.t$('header.setting.save')),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSetting($event)))
              }, null, 8 /* PROPS */, _hoisted_28)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}